import PropTypes from 'prop-types';
import React, { useRef, useState } from 'react';
import { useConnect } from 'redux-bundler-hook';
import Tooltip from 'root/components/molecules/Tooltip';

import {
  StyledAvatarWrapper,
  StyledRemainingTeam,
  StyledUserAvatar,
  StyledWorkspaceTeamList,
} from './styles';

const WorkspaceTeamList = ({ disabled, boardId }) => {
  const { teamMembersByIdWithoutChatbot: teamMembersById } = useConnect(
    'selectTeamMembersByIdWithoutChatbot',
  );
  const ref = useRef(null);
  const [hover, setHover] = useState(false);
  const team = teamMembersById.filter((member) =>
    member.assignedBoardIDs.includes(boardId),
  );

  if (!team.length) return null;

  // display first three Team
  const firstThreeTeamMembers = team.slice(0, 3);

  // get the Team beyond the first three to display in a tooltip
  const remainingTeamMembers = team.slice(3);

  // get a count for the remainingTeam
  const remainingTeamLength = remainingTeamMembers.length;

  return (
    <StyledWorkspaceTeamList>
      {firstThreeTeamMembers.length
        ? firstThreeTeamMembers.map(({ userId }) => (
            <StyledAvatarWrapper key={userId}>
              <StyledUserAvatar id={userId} withTooltip={!disabled} />
            </StyledAvatarWrapper>
          ))
        : null}
      {remainingTeamLength ? (
        <StyledRemainingTeam
          onMouseEnter={() => !disabled && setHover(true)}
          onMouseLeave={() => !disabled && setHover(false)}
          ref={ref}
        >
          {`+${remainingTeamLength}`}
          <Tooltip
            active={hover}
            parent={ref}
            position="bottom"
            variant="arrow"
          >
            {remainingTeamMembers.map(({ userId, firstName, lastName }) => (
              <p key={userId}>{`${firstName} ${lastName}`}</p>
            ))}
          </Tooltip>
        </StyledRemainingTeam>
      ) : null}
    </StyledWorkspaceTeamList>
  );
};

WorkspaceTeamList.propTypes = {
  boardId: PropTypes.string,
  disabled: PropTypes.bool,
};

WorkspaceTeamList.defaultProps = {
  boardId: undefined,
  disabled: false,
};

export default WorkspaceTeamList;
